<template>
  <div id="app">
    <Intro />
    <Doc />
    <Footer />
  </div>
</template>

<script>
import Intro from './components/Intro'
import Doc from './components/Doc'
import Footer from './components/Footer'

export default {
  name: 'app',
  components: {
    Intro,
    Doc,
    Footer
  },
  mounted () {
    hljs.initHighlightingOnLoad()
  }
}
</script>

<style lang="less">

</style>
